import React from 'react';
import {FOOTER_MODULE} from "../footer-module.consts";
import classNames from "classnames";
import styles from "../styles/footer.module.scss";
import {FooterModuleLangPicker} from "./footer-module.lang-picker";
import {observer} from "mobx-react";

export const FooterModuleBottom = observer(({controller}) => {
  const {state: {copyrightText, versionLabel, isBottomNavBarDisplay, shouldRenderExpandLangMenu}} = controller;

  const versionProps = {
    className: classNames(styles.version),
    onClick: () => controller.action(FOOTER_MODULE.ACTION_TYPES.versionClick)
  }

  return (
    <div className={classNames(styles.bottom_container, {[styles.bottom_extended_container]: isBottomNavBarDisplay})}>
      <FooterModuleLangPicker shouldRenderLangMenu={shouldRenderExpandLangMenu}/>
      <div className={classNames(styles.bottom)}>
        <div className={classNames(styles.copyright)}>{copyrightText}</div>
        <div className={classNames(styles.gamble)}/>
        <div {...versionProps}>{versionLabel}</div>
      </div>
    </div>
  );
})
